var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IngredientContainer",style:({
    width: _vm.cssProp(716),
    height: _vm.cssProp(625),
    pointerEvents: 'none',
    position: 'relative'
  })},[(_vm.productIwcImg && _vm.productIwcImgPos)?_c('div',[_c('img',{staticClass:"IngredientWizardCompositionImage",style:({
        top: _vm.cssProp(_vm.productIwcImgPos.top, '0'),
        left: _vm.cssProp(_vm.productIwcImgPos.left - 180, '0'),
        width: _vm.cssProp(_vm.productIwcImgPos.width, 'auto'),
        height: _vm.cssProp(_vm.productIwcImgPos.height, 'auto'),
        zIndex: _vm.productIwcImgPos['z_index']
      }),attrs:{"src":_vm.productIwcImg}})]):_vm._e(),_vm._l((_vm.compositionImageGroups),function(imageGroup){return _c('div',{key:imageGroup.groupId},_vm._l((imageGroup.items),function(imageItem){return _c('div',{key:imageItem.item_key},[(imageItem.position)?_c('img',{staticClass:"Ingredient",style:({
          top: _vm.cssProp(imageItem.position.top, '0'),
          left: _vm.cssProp(imageItem.position.left - 180, '0'),
          width: _vm.cssProp(imageItem.position.width, 'auto'),
          height: _vm.cssProp(imageItem.position.height, 'auto'),
          zIndex: imageItem.position['z_index']
        }),attrs:{"src":imageItem.composition_image}}):_vm._e()])}),0)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }